import cn from 'classnames';
import type { ReactNode } from 'react';
import { Button } from '../../button';
import { Flex } from '../../flex';
import { Icon } from '../../icons';
import styles from './input-attachment-wrapper.module.css';

export type InputAttachmentWrapperProperties = {
  children: ReactNode;
  className?: string;
  onRemove: () => void;
};

const InputAttachmentWrapper = ({ children, className, onRemove }: InputAttachmentWrapperProperties) => (
  <Flex align="center" className={cn(styles.wrapper, className)} gap="xxs" wrap={false}>
    <Flex className={styles.shrink} flex="1 1 0" vertical>
      {children}
    </Flex>
    <Button aria-label="Remove attachment" icon={<Icon icon="close-line" />} onClick={onRemove} type="link-secondary" />
  </Flex>
);

export default InputAttachmentWrapper;
